<template>
  <form ref="deviceFileUploadForm" >
    <div class="form-inline">
      <!--<label>Upload: </label>-->
      <input type="file"
             enctype="multipart/form-data"
             id="file"
             ref="deviceFile" @change.prevent.stop="handleFileUpload"
             class="form-control form-control-file mr-md-2 mr-2"/>
    </div>
  </form>
</template>
<script>
export default {
  name: 'device-file-upload',
  data() {
    return {
      file: null
    }
  },

  methods: {
    handleFileUpload() {
      this.updateFileRef();
      this.$emit('device-data-upload', this.file);
    },
    
    /**
     * updates reference to local file for the file chooser
     */
    updateFileRef () {
      this.file = this.$refs.deviceFile.files[0];
    }
  },
}
</script>

<style scoped lang="scss">
  .btn {
    font-size: 0.9rem;
  }
  input[type="text"] {
    font-size: 0.9rem;
  }
  input[type="file"] {
    font-size: 12px;
    margin: 0;
    height: 100%;
    /*width: 70%;*/
  }
</style>
